import classNames from "classnames";
import React from "react";
import { CardIcon, Text, Title } from "components/commons";
import locale from "localization";
import { formatAmount } from "utils";
import styles from "./account-information-card.module.scss";

const AccountInformationCard = ({
  header,
  label,
  amount,
  fleetCardNo,
  transactionCount,
  purchaseOrderNo,
  purchaseOrderLabel = locale.purchaseOrderNo,
  zeroBalanceMessage,
  className,
  children,
}) => {
  return (
    <div className={classNames(styles.accountInformationCard, className)}>
      {header && <Title className={styles.header}>{header}</Title>}
      <div className={styles.box}>
        <div className={styles.balanceRow}>
          <CardIcon />
          <div className={styles.balanceBlock}>
            <Text className={styles.balanceValue}>{formatAmount(amount)}</Text>
            <Text className={styles.balanceLabel}>{label}</Text>
          </div>
          {zeroBalanceMessage && (
            <Text className={styles.zeroBalanceMessage}>{zeroBalanceMessage}</Text>
          )}
        </div>
        {children}
        <div className={styles.table}>
          <div className={styles.row}>
            <label>{locale.fleetCardNo}</label>
            <label>{fleetCardNo}</label>
          </div>
          {purchaseOrderNo && (
            <div className={styles.row}>
              <label>{purchaseOrderLabel}</label>
              <label>{purchaseOrderNo}</label>
            </div>
          )}
          <div className={styles.row}>
            <label>{locale.fleetCardTransactionCount}</label>
            <label>{transactionCount}</label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountInformationCard;
